import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, List, Modal, Select, Spin, Tabs } from "antd";
import type { TabsProps } from "antd";
import { useLocation } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import ReactEcharts from "echarts-for-react";
import { RootState } from "@/redux/reducer/store";
import "./index.less";
import Search from "./components/Search";
import {
    sagaActionTypes,
    searchTargetCoordinate,
    showAddBookmarkFailedFunc,
    showAddBookmarkSuccessFunc,
    updateCurrentLocation,
    updateParamModel,
    updateWeatherForcastdailyList
} from "@/redux/actions/commonAction";
import {
    BookMarkIcon,
    WaterFallIcon,
    WindSpeedIcon
} from "@/resource/IconComponents";
import {
    ILocationModel,
    IWeatherForcastDailyListResModel
} from "@/util/http/responseType";
import WeatherCard from "./components/WeatherCard";

import IF from "@/components/IF";
import ForcastButton from "@/components/ForecastProviderButton";
import Sunny from "@/resource/images/png/sunny.png";
import { API_LOCAL_URL } from "@/util/http/config";
import useHourlyTabs from "./components/Hooks/useHourlyTabs";
import {checkServiceTokenIsValid} from "util/http/index";

const count = 0;
interface locationModal {
    longitude: number;
    latitude: number;
    adminName: string;
    name:string;
    countryCode: string;
    placeId: string;
}
const AccurateWeather = () => {

    const dispatch = useDispatch();
    const urlLocation = useLocation();

    const {
        locations,
        bookmarks,
        weatherForcastDailyList,
        localDailyWidgetWeather,
        currentLanguage,
        chartData,
        cropsItems,
        cropsSpray,
        topInfoCardLoading,
        weatherListLoading,
        sprayLoading,
        paramModel,
        weather24HoursData,
        weather8HoursData,
        weatherDayData,
        showAddBookSuccess,
        showAddBookFailed,
        searchCoordinateResult,
        serviceToken,
        searchByPlace,
        searchByPlaceResult
    } = useSelector((state: RootState) => state.commonReducer);

    //获取server localtime
    useEffect(() => {
        if (Array.isArray(localDailyWidgetWeather) && localDailyWidgetWeather.length > 0) {
            const localDateTime = localDailyWidgetWeather[0]?.localDateTime;
            if (localDateTime) {
                // 只截取日期部分
                const datePart = localDateTime.split(" ")[0];
                //console.log("222222222datePart", datePart);
                setWeatherDate(datePart); // 赋值给weatherDate
            }
        }
    }, [localDailyWidgetWeather]);
    // add google analysis
    useEffect(() => {
        console.log("just invoke once");
        const head = document.getElementsByTagName("head")[0];
        const googleAnalyticsCode = "G-CY2C82ZCLX";
        const googleAnalyticsFirstScript = document.createElement("script");
        googleAnalyticsFirstScript.async = true;
        googleAnalyticsFirstScript.src =
          "https://www.googletagmanager.com/gtag/js?id=" + googleAnalyticsCode;

        const googleAnalyticsSecondScript = document.createElement("script");
        googleAnalyticsSecondScript.innerHTML =
          "    window.dataLayer = window.dataLayer || [];\n" +
          "    function gtag(){dataLayer.push(arguments);}\n" +
          "    gtag('js', new Date());\n" +
          "\n" +
          "    gtag('config', '" +
          googleAnalyticsCode +
          "',{\n" +
          "cookie_flags:'max-age=7200;secure;samesite-none'" +
          "});";

        head.insertBefore(googleAnalyticsSecondScript, head.firstChild);
        head.insertBefore(googleAnalyticsFirstScript, head.firstChild);
    }, []);

    const [inputText, setInputText] = useState("");
    const [locationListShow, setLocationListShow] = useState(false);
    const [currentLocation, setCurrentLocation] = useState<ILocationModel>();
    const [showGraphicChart, setShowGraphicChart] = useState(false);
    const [currentWeatherDate, setCurrentWeatherDate] = useState<IWeatherForcastDailyListResModel>();
    const [currentKey, setCurrentKey] = useState<{ key: string, label: string }>();
    const [warningText, setWarningText] = useState("Bookmark added successfully!");
    const [date, setDate] = useState<string>();

    //start use component code
    //定义来自location-search-widget的状态值
    const [locationData, setLocationData] = useState<locationModal>();
    const [latFromLocationSearch, setLatFromLocationSearch] = useState<string>(null);
    const [longFromLocationSearch, setLongFromLocationSearch] = useState<string>(null);
    const [countryCodeFromLocationSearch, setCountryCodeFromLocationSearch] = useState<string>(null);
    const [inputValue,setInputValue]=useState<string>(null);

    // 获取 URL 的查询参数部分
    // const searchParams = new URLSearchParams(window.location.search);

    // const [latFromUrl, setLatFromUrl] = useState<string>(null);
    // const [longFromUrl, setLongFromUrl] = useState<string>(null);
    // const [languageFromUrl, setLanguageFromUrl] = useState<string>(null);
    // const [countryFromUrl, setCountryFromUrl] = useState<string>(null);
    // const [unitFromUrl, setUnitFromUrl] = useState<string>(null);
    // const [numberofforecastFromUrl, setNumberofforecastFromUrl] = useState<string>(null);

    // useEffect(() => {
    //     // 从URL中筛选出所需的参数值
    //     setLanguageFromUrl(searchParams.get("language"));
    //     setCountryFromUrl(searchParams.get("country"));
    //     setNumberofforecastFromUrl(searchParams.get("numberofforecast"));
    //     setLatFromUrl(searchParams.get("Lat"));
    //     setLongFromUrl(searchParams.get("Long"));
    //     setUnitFromUrl(searchParams.get("unit"));
    // }, [searchParams]);

    useEffect(() => {
        customElements.whenDefined("location-search-widget").then(() => {
            const handlePositionCallback = (event: CustomEvent) => {
                if(event.detail==="no result")
                {
                    dispatch(searchTargetCoordinate(true));
                }
                // 修正1：忽略大小写检查，确保匹配更健壮
                else if (typeof event.detail === "string" &&
                 event.detail.toLowerCase().includes("gps no result")) {
                    console.log("GPS Failed");
                }
                else{
                    if(Array.isArray(event.detail)){
                        console.log("search component all values",event.detail);
                    }
                    else{
                        setLocationData(event.detail);
                        console.log("search component selected",event.detail);
                        const tmpLocation: ILocationModel = {
                            AdminName: { _text: event.detail.adminName },
                            AdminName1: { _text: "" }, // 可根据实际需求填充默认值或从其他来源获取
                            AdminName2: { _text: "" }, // 同上
                            AdminName3: undefined, // 或根据实际情况设置为null或其他值
                            AltName: { _text: "" },
                            AreaId: { _text: "" },
                            CountryCode: { _text: event.detail.countryCode },
                            CountryName: { _text: "" }, // 可根据需要补充
                            Latitude: { _text: event.detail.latitude.toString() }, // 转换为字符串
                            Longitude: { _text: event.detail.longitude.toString() }, // 转换为字符串
                            Name: { _text: event.detail.name },
                            PlaceId: { _text: event.detail.placeId },
                            PostalCode: undefined, // 或根据实际情况设置
                            Score: { _text: "" },
                        };
                        setCurrentLocation(tmpLocation);
                    }
                }
            };
            document.addEventListener("positionCallback", handlePositionCallback as EventListener);

            return () => {
                document.removeEventListener("positionCallback", handlePositionCallback as EventListener);
            };
        });
    }, [inputValue]);

    useEffect(() => {
        if (locationData !== undefined) {
            console.log("6666 locationData",locationData);
            setCountryCodeFromLocationSearch(locationData?.countryCode);
            setLatFromLocationSearch((locationData?.latitude)?.toString());
            setLongFromLocationSearch(locationData?.longitude?.toString());
            setInputValue(locationData?.name);
            setSelectPlaceName("");
        }
    }, [locationData]);

    const getFormattedDate = (): string => {
        const today = new Date();
        const year = today.getFullYear();
        // 月份从 0 开始，所以要加 1，并且不足两位时前面补 0
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}/${month}/${day}`;
    };
    const [weatherDate,setWeatherDate] = useState(getFormattedDate());

    // 生成一个唯一的 key，用于强制组件重新渲染
    const dailyKey = `dailyKey-${inputValue}-${latFromLocationSearch}-${longFromLocationSearch}-${countryCodeFromLocationSearch}`;
    const currentconditionKey = `currentconditionKey-${latFromLocationSearch}-${longFromLocationSearch}-${countryCodeFromLocationSearch}`;
    const sprayingKey = `sprayingKey-${weatherDate}-${latFromLocationSearch}-${longFromLocationSearch}-${countryCodeFromLocationSearch}`;
    const hourlyweatherdataKey = `hourlyweatherdataKey-${weatherDate}-${latFromLocationSearch}-${longFromLocationSearch}-${countryCodeFromLocationSearch}`;
    const eighthourlyweatherdataKey = `eighthourlyweatherdataKey-${weatherDate}-${latFromLocationSearch}-${longFromLocationSearch}-${countryCodeFromLocationSearch}`;
    const dailyweatherdataKey = `dailyweatherdataKey-${weatherDate}-${latFromLocationSearch}-${longFromLocationSearch}-${countryCodeFromLocationSearch}`;

    //重新定义tabItems
    const newTabItems: TabsProps["items"] = [
        {
            key: "hourly",
            label: currentLanguage.txt_Hourly,
            children:
             <hourlyweatherdata-widget
                 key={hourlyweatherdataKey}
                 lat={latFromLocationSearch??(paramModel?.latitude?.toString())}
                 lon={longFromLocationSearch??(paramModel?.longitude?.toString())}
                 unit={paramModel?.unit??"metric"}
                 date={weatherDate}
                 source="weatherdata"
                 language={paramModel?.language}
                 country-code={paramModel?.countryCode}
                 data-source="meteoblue"
             ></hourlyweatherdata-widget>
        },
        {
            key: "8hourly",
            label: currentLanguage.txt_8Hourly,
            children: <eighthourlyweatherdata-widget
                key={eighthourlyweatherdataKey}
                lat={latFromLocationSearch??(paramModel?.latitude?.toString())}
                lon={longFromLocationSearch??(paramModel?.longitude?.toString())}
                unit={paramModel?.unit??"metric"}
                date={weatherDate}
                source="weatherdata"
                language={paramModel?.language}
                country-code={paramModel?.countryCode}
                data-source="meteoblue"
            ></eighthourlyweatherdata-widget>
        },
        {
            key: "daily",
            label: currentLanguage.txt_Daily,
            children: <dailyweatherdata-widget
                key={dailyweatherdataKey}
                lat={latFromLocationSearch}
                lon={longFromLocationSearch}
                unit={paramModel?.unit??"metric"}
                date={weatherDate}
                source="weatherdata"
                language={paramModel?.language}
                country-code={paramModel?.countryCode}
                data-source="meteoblue"
            ></dailyweatherdata-widget>
        },
    ];

    //为了拿到<daily-widget />的回调日期
    const widgetRef = useRef<HTMLElement>(null);
    const [isReady,setIsReady] = useState(false);


    useEffect(() => {
        const widget = widgetRef.current;
        if (!widget) return;

        const onWidgetReady = (e: Event | any) => {
            console.log("ggg ✅ widgetReady 触发", e?.detail);
            try {
                console.log("ggg dateSelected 监听器已添加");
                if(e?.detail === true){
                    setIsReady(true);
                }
                setIsReady(true);

            } catch (error) {
                console.error("ggg 添加监听器失败:", error);
            }
        };

        widget.addEventListener("widgetReady", onWidgetReady);
        console.log("ggg widgetReady 监听器已添加");

        return () => {
            console.log("ggg 执行清理");
            widget.removeEventListener("widgetReady", onWidgetReady);
        };
    }, []);

    useEffect(()=>{
        if(isReady){
            const widget = widgetRef.current;
            if (!widget) return;

            const handleDateSelected = (e: Event) => {
                const customEvent = e as CustomEvent<string>;
                console.log("ggg Stencil 事件触发:", customEvent.detail);
                setWeatherDate(customEvent.detail);
            };

            widget.addEventListener("dateSelected", handleDateSelected);
            console.log("ggg final add ");
        }
    },[dailyKey, isReady]);

    // 截取第一个逗号前的数据
    const getFirstPart = (str: string) => {
    // 查找第一个逗号的索引
        const commaIndex = str.indexOf(",");
        // 如果存在逗号则截取，否则返回原字符串
        return commaIndex !== -1 ? str.substring(0, commaIndex) : str;
    };
    //end use component code


    const addBookmarkButtonClicked = () => {
        const tmpLocation: ILocationModel = {
            AdminName: { _text: locationData.adminName },
            AdminName1: { _text: "" }, // 可根据实际需求填充默认值或从其他来源获取
            AdminName2: { _text: "" }, // 同上
            AdminName3: undefined, // 或根据实际情况设置为null或其他值
            AltName: { _text: "" },
            AreaId: { _text: "" },
            CountryCode: { _text: locationData.countryCode },
            CountryName: { _text: "" }, // 可根据需要补充
            Latitude: { _text: locationData.latitude.toString() }, // 转换为字符串
            Longitude: { _text: locationData.longitude.toString() }, // 转换为字符串
            Name: { _text: locationData.name },
            PlaceId: { _text: locationData.placeId },
            PostalCode: undefined, // 或根据实际情况设置
            Score: { _text: "" },
        };
        setCurrentLocation(tmpLocation);
        dispatch({ type: sagaActionTypes.SAGA_ADD_BOOKMARK, payload: {
            // eslint-disable-next-line max-len
            securityStr: paramModel.security,
            currentLocation: tmpLocation,
            emailid:paramModel.emailid
        }});
    };

    const checkServiceTokenIsValidFunc = async()=>{
        try{
            const res = await checkServiceTokenIsValid(paramModel.security);
            setShowPageByToken(res.data);
            if(!res.data){
                const element1 = document.querySelector(".dark-theme") as HTMLElement;
                if(element1){
                    element1.style.backgroundColor = "white";
                }
            }
        }
        catch(error){
            console.log("error",error);
        }
    };

    const [showPageByToken,setShowPageByToken] = useState(true);
    const isFirstRender = useRef(true);

    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false; // first render
            return; // when first render, do nothing
        }
        if(paramModel?.security === "no-value" || serviceToken === "no-value"){
            setShowPageByToken(false);
        }
        if(serviceToken && serviceToken!= "no-value"){
            checkServiceTokenIsValidFunc();
        }
    },[serviceToken,paramModel?.security]);


    useEffect(() => {
        if(searchByPlaceResult){
            setCurrentLocation(locations[0]);
            setInputText(locations[0]?.AdminName?._text?.split(",")[0]);
        }
        else{
            if (locations.length > 0 && locations.length !== 1) {
                setLocationListShow(true);
            }
            if (locations.length === 1) {
                setCurrentLocation(locations[0]);
                setInputText(locations[0]?.AdminName?._text?.split(",")[0]);
            }
        }

    }, [locations,searchByPlaceResult]);

    useEffect(()=>{
        if(searchByPlace){
            if (paramModel.latitude) {
                dispatch({
                    type: sagaActionTypes.SAGA_COORDINATE_SEARCH,
                    payload: {searchText:`${paramModel.longitude},${paramModel.latitude}`}
                });
            }
        }
    },[searchByPlace]);

    useEffect(() => {
        setWarningText(currentLanguage["Bookmark Added successfully"]);
    }, [currentLanguage]);

    useEffect(() => {
        if (currentLocation) {
            dispatch({
                type: sagaActionTypes.SAGA_GET_WEATHERFORCAST_DAILY_LIST,
                payload: {
                    ...currentLocation,
                    cultureCode:  `${paramModel.language}-${paramModel.countryCode}`,
                    numberOfDays: paramModel.numberOfDays,
                    isGreencastForecast: false
                }});
            dispatch({
                type: sagaActionTypes.SAGA_GET_LOCAL_HOURLY_WIDGET,
                payload: {
                    ...currentLocation,
                    cultureCode:  `${paramModel.language}-${paramModel.countryCode}`,
                    isNowcast: true,
                    isGreencastForecast: false
                }});
            dispatch({ type: sagaActionTypes.SAGA_GET_CHART_DATA, payload: {
                latitude: parseFloat(currentLocation.Latitude._text),
                longitude: parseFloat(currentLocation.Longitude._text),
                cultureCode: `${paramModel.language}-${paramModel.countryCode}`,
                numberOfDays: paramModel.numberOfDays,
                isGreencastForecast: false
            }});
            dispatch({ type: sagaActionTypes.SAGA_GET_CORPS_SPRAY, payload: {
                cultureCode: `${paramModel.language}-${paramModel.countryCode}`,
                latitude: parseFloat(currentLocation.Latitude._text),
                longitude: parseFloat(currentLocation.Longitude._text),
                modelName: paramModel.modelName,
                numberOfDays: paramModel.numberOfDays,
                isGreencastForecast: false
            }});
            dispatch({
                type: sagaActionTypes.SAGA_UPDATE_CURRENT_LANGUAGE,
                payload: { strCultureCode: `${paramModel.language}-${paramModel.countryCode}`, pubname: "glibsip03p" }});
            dispatch({ type: sagaActionTypes.SAGA_GET_AGGREGATED_WEATHER, payload: {
                cultureCode: `${paramModel.language}-${paramModel.countryCode}`,
                latitude: parseFloat(currentLocation.Latitude._text),
                longitude: parseFloat(currentLocation.Longitude._text),
                numberOfDays: paramModel.numberOfDays,
                unit: paramModel.unit,
                isForFiveDaysWeather: false,
                isGreencastForecast: false
            } });
        }
    }, [currentLocation]);

    useEffect(() => {
        const securityReg = /(?<=securitykey=)[\w\\/+=]*/i;
        const themeReg = /(?<=theme=)[\w]*/i;
        const countryCodeReg = /(?<=country=)[\w]*/i;
        const latitudeReg = /(?<=[Ll]at=)[+-.\w]*/i;
        const longitudeReg = /(?<=[Ll]ong=)[+-.\w]*/i;
        const languageReg = /(?<=[Ll]anguage=)[\w]*/i;
        const numberOfDaysReg = /(?<=numberofforecast=)[\w]*/i;
        const unitReg = /(?<=unit=)[\w]*/i;
        const emailidReg = /emailid=([^&]+)/i;
        const placenameReg = /placename=([^&]+)/i;
        const bookmarksReg = /bookmarks=([^&]+)/i;
        const modelNameReg = /(?<=[Uu]ser[Ss]praywdws=)[\w]*/;
        const cropListReg = /(?<=[Cc]ountry[Ss]praywdws=)[\w%|]*/;

        const securityRes = urlLocation.search.match(securityReg);
        const themeRes = urlLocation.search.match(themeReg);
        const modelNameRes = urlLocation.search.match(modelNameReg);
        const countryCodeRes = urlLocation.search.match(countryCodeReg);
        const latitudeRes = urlLocation.search.match(latitudeReg);
        const longitudeRes = urlLocation.search.match(longitudeReg);
        const languageRes = urlLocation.search.match(languageReg);
        const cropListRes = urlLocation.search.match(cropListReg);
        const numberOfDaysRes = urlLocation.search.match(numberOfDaysReg);
        const unitRes = urlLocation.search.match(unitReg);
        const emailidRes=urlLocation.search.match(emailidReg);
        const placenameRes=urlLocation.search.match(placenameReg);
        const bookmarksRes=urlLocation.search.match(bookmarksReg);

        const security = securityRes ? securityRes[0] : "no-value";
        const theme = (themeRes && themeRes[0] ? themeRes[0]?.toLowerCase() : "light");
        const countryCode = countryCodeRes && countryCodeRes[0] ? countryCodeRes[0]?.toUpperCase() : "GB";
        const latitude = parseFloat(latitudeRes[0] || "0");
        const longitude = parseFloat(longitudeRes[0] || "0");
        const language = languageRes && languageRes[0] ? languageRes[0]?.toLowerCase() : "en";
        const numberOfDays = numberOfDaysRes[0];
        const unit = unitRes && unitRes[0] ? unitRes[0]?.toLowerCase() : "metric";
        const placename=placenameRes && placenameRes[1]||null;
        const bookmarksPara=bookmarksRes && bookmarksRes[1]||null;
        const modelName = modelNameRes && modelNameRes[0];
        let cropList = cropListRes[0];
        cropList = cropList.replace("%7C", "|");

        let emailid;

        if (emailidRes&&emailidRes!=null) {
            emailid = emailidRes[1];
            console.log("Email ID",emailid);
        } else {
            console.log("Email ID not found,should be seted default email");
            const countrycode=countryCode?.toLowerCase();
            emailid="cehub-"+countrycode+"@syngentaprocessmail.com";
        }

        dispatch(updateParamModel({
            security,
            theme,
            modelName,
            countryCode,
            latitude,
            longitude,
            language,
            cropList,
            numberOfDays: parseFloat(numberOfDays),
            unit,
            emailid,
            placename,
            bookmarksPara
        }));

        if (securityRes) {
            dispatch({ type: sagaActionTypes.SAGA_GET_USERNAME, payload: {
                security, countryCode,
                emailid
            }});
        }
        if (theme) {
            const rootElement = document.getElementById("root");
            switch (theme) {
                case "dark": {
                    rootElement.className = "dark-theme";
                    break;
                }
                case "light": {
                    rootElement.className = "light-theme";
                    break;
                }
            }
        }
    }, [urlLocation]);

    // useEffect(() => {
    //     if (paramModel.latitude) {
    //         dispatch({type: sagaActionTypes.SAGA_GET_CROPS, payload: {
    //             cropList: `${paramModel.modelName}|${paramModel.cropList}`,
    //             cultureCode: `${paramModel.language}-${paramModel.countryCode}`,
    //         }});
    //         dispatch({
    //             type: sagaActionTypes.SAGA_COORDINATE_SEARCH,
    //             payload: {searchText:`${paramModel.longitude},${paramModel.latitude}`}
    //         });
    //     }
    // }, [paramModel]);


    useEffect(() => {
        if(!paramModel.placename){
            if (paramModel.latitude) {
                dispatch({type: sagaActionTypes.SAGA_GET_CROPS, payload: {
                    cropList: `${paramModel.modelName}|${paramModel.cropList}`,
                    cultureCode: `${paramModel.language}-${paramModel.countryCode}`,
                }});
                dispatch({
                    type: sagaActionTypes.SAGA_COORDINATE_SEARCH,
                    payload: {searchText:`${paramModel.longitude},${paramModel.latitude}`}
                });
            }
        }else{
            let currentCountryCode = paramModel.countryCode;
            if (currentCountryCode.toUpperCase() === "AU") {
                currentCountryCode = "AU;NZ";
            }
            if (currentCountryCode.toUpperCase() === "GB") {
                currentCountryCode = "GB;IE";
            }
            dispatch({
                type: sagaActionTypes.SAGA_COORDINATE_SEARCH,
                payload: {searchText: `${paramModel.placename},${currentCountryCode}`,
                    searchFlag: true
                }
            });
            dispatch({type: sagaActionTypes.SAGA_GET_CROPS, payload: {
                cropList: `${paramModel.modelName}|${paramModel.cropList}`,
                cultureCode: `${paramModel.language}-${paramModel.countryCode}`,
            }});
        }
    }, [paramModel]);

    useEffect(() => {
        if (currentKey) {
            dispatch({ type: sagaActionTypes.SAGA_GET_CORPS_SPRAY, payload: {
                cultureCode: `${paramModel.language}-${paramModel.countryCode}`,
                latitude: parseFloat(currentLocation.Latitude._text),
                longitude: parseFloat(currentLocation.Longitude._text),
                modelName: currentKey.key,
                numberOfDays: paramModel.numberOfDays,
                isGreencastForecast: false
            }});
        }
    }, [currentKey]);

    useEffect(() => {
        if (weatherForcastDailyList.length > 0 && !currentWeatherDate) {
            setCurrentWeatherDate(weatherForcastDailyList[0]);
        }
    }, [weatherForcastDailyList]);

    useEffect(() => {
        if (Object.keys(weather24HoursData.defaultShowIcon).length > 0) {
            if (currentWeatherDate) {
                const date = currentWeatherDate.date?.match(/\d\d\d\d\/\d\d\/\d\d/)[0];
                setDate(date);
            } else {
                const date = Object.keys(weather24HoursData.hours24Data)[0];
                setDate(date);
            }
        }
    }, [currentWeatherDate, weather24HoursData]);

    const option = {
        title: {
            text: currentLanguage.txt_Temperature,
            top: 10,
            left: 6
        },
        legend: {
            show: true,
            left: 170,
            top: 12,
            itemStyle: {
                opacity: 0,
                itemWidth: 40,
                itemHeight: 10
            }
        },
        tooltip: {
            trigger: "axis"
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "7%",
            containLabel: true
        },
        xAxis: [
            {
                type: "category",
                boundaryGap: false,
                position: "top",
                data: chartData?.date,
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: "solid",
                        color: "#DBD4D4",
                        width: 1.5
                    },
                },
                color: "#868CA2",
                fontSize: "8px",
                axisLabel: {
                    interval: 24,
                    formatter: (val) => {
                        const target = val.split(" ");
                        return `${target[0]}${target[1]}${target[2]}`;
                    }
                }
            }
        ],
        yAxis: [
            {
                name: paramModel.unit === "metric" ? "℃" : "°F",
                nameTextStyle: {
                    padding: [0, 0, 25, 20]
                },
                type: "value",
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: "dashed",
                        color: "#DBD4D4",
                        width: 1.5
                    }
                }
            }
        ],
        series: [
            {
                name: " ",
                type: "line",
                stack: "Total",
                smooth: true,
                lineStyle: {
                    width: 1,
                    color: "rgba(235, 183, 0, 1)"
                },

                showSymbol: false,
                areaStyle: {
                    opacity: 0.8,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: "rgba(235, 183, 0, 0.54)"
                        },
                        {
                            offset: 1,
                            color: "rgba(255, 255, 255, 0)"
                        }
                    ])
                },
                emphasis: {
                    focus: "series"
                },
                data: chartData?.temperature,
                label: {
                    formatter: "{name|{b}\n{value|{d}%}}",
                    rich: {
                        name: {
                            fontSize: 14,
                            color: "#666"
                        },
                        value: {
                            fontSize: 18,
                            color: "red"
                        }
                    }
                }
            },
        ]
    };

    const secondChartOption = {
        title: {
            text: currentLanguage.txt_Precipitaion,
            top: 10,
            left: 6
        },
        legend: {
            show: true,
            left: 130,
            top: 11,
            itemWidth: 15,
            itemHeight: 15
        },
        grid: {
            left: "5%",
            right: "4%",
            bottom: "7%",
            containLabel: true
        },
        tooltip: {
            trigger: "axis"
        },
        xAxis: {
            data: chartData?.date,
            position: "top",
            splitLine: {
                show: true,
                lineStyle: {
                    type: "solid",
                    color: "#DBD4D4",
                    width: 1.5
                }
            },
            axisLabel: {
                interval: 24,
                formatter: (val) => {
                    const target = val.split(" ");
                    return `${target[0]}${target[1]}${target[2]}`;
                }
            }
        },
        yAxis: {
            name: paramModel.unit === "metric" ? "mm" : "in",
            nameTextStyle: {
                padding: [0, 0, 25, -5]
            },
            splitLine: {
                show: true,
                lineStyle: {
                    type: "dashed",
                    color: "#DBD4D4",
                    width: 1.5
                }
            }
        },
        series: [
            {
                name: " ",
                type: "bar",
                data: chartData?.precip,
                emphasis: {
                    focus: "series"
                },
                animationDelay: function (idx) {
                    return idx * 10;
                },
                itemStyle: {
                    normal: {
                        color: "#20AFFF"
                    }
                }
            },
        ],
        animationEasing: "elasticOut",
    };

    const [selectPlaceName,setSelectPlaceName]=useState("");
    const placeNameOnchange=(item)=>{
        setLongFromLocationSearch(item?.bookmark?.longitude);
        setLatFromLocationSearch(item?.bookmark?.latitude);
        setCountryCodeFromLocationSearch(item?.bookmark?.countryCode);
        setInputValue("");

        setSelectPlaceName(item);
        setInputText("");
    };

    //get windowWidth
    const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const useWindowWidth = () => {
        const [width, setWidth] = useState(getWidth);

        useEffect(() => {
            const handleResize = () => {
                setWidth(getWidth());
            };

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return width;
    };
    const windowWidth = useWindowWidth();
    const [agWeather,setAgWeather]=useState("flex");
    const [agWeathermobile,setAgWeathermobile]=useState("none");
    useEffect(() => {
        if((paramModel.countryCode?.toUpperCase() == "ZA") && (windowWidth<=576)){
            setAgWeather("none");
            setAgWeathermobile("flex");
        }else
        {
            setAgWeather("flex");
            setAgWeathermobile("none");
        }
    }, [(paramModel.countryCode),windowWidth]);


    return (
        <>
            {
                showPageByToken?
                    <div className="accurate-weather-container">
                        {/* It is about bookmark warning modal*/}
                        <Modal
                            title={currentLanguage.txt_Warning}
                            open={showAddBookSuccess || showAddBookFailed}
                            okText={currentLanguage.txt_Ok}
                            cancelText={currentLanguage.txt_Cancel}
                            onCancel={() => {
                                dispatch({type: sagaActionTypes.SAGA_GET_BOOKMARK, payload: {
                                    countryCode: paramModel.countryCode,
                                    emailid: paramModel.emailid
                                } });
                                dispatch(showAddBookmarkSuccessFunc(false));
                                dispatch(showAddBookmarkFailedFunc(false));
                            }}
                            onOk={() => {
                                dispatch({type: sagaActionTypes.SAGA_GET_BOOKMARK, payload: {
                                    countryCode: paramModel.countryCode,
                                    emailid: paramModel.emailid
                                } });
                                dispatch(showAddBookmarkSuccessFunc(false));
                                dispatch(showAddBookmarkFailedFunc(false));
                            }}
                        >
                            {/* <label>{warningText}</label> */}
                            <label>{showAddBookSuccess && currentLanguage["Bookmark Added successfully"] || showAddBookFailed && currentLanguage["txt_addBookMarkFailed"]}</label>
                        </Modal>
                        {/* It is search location warning modal*/}
                        <Modal
                            title={currentLanguage.txt_Warning}
                            open={searchCoordinateResult}
                            okText={currentLanguage.txt_Ok}
                            cancelText={currentLanguage.txt_Cancel}
                            onCancel={() => {
                                dispatch(searchTargetCoordinate(false));
                            }}
                            onOk={() => {
                                dispatch(searchTargetCoordinate(false));
                            }}
                        >
                            <label>{currentLanguage.No_place_found}</label>
                        </Modal>
                        {/* left location-1 search */}
                        <div className="accurate-left">
                            <div className="head-title">
                                {currentLanguage.txt_AccurateWeather}
                            </div>
                            <div style={{marginTop:"18px"}}>
                                <location-search-widget
                                    gps-enable="true"
                                    language={paramModel?.language}
                                    lat={paramModel?.latitude?.toString()}
                                    lon={paramModel?.longitude?.toString()}
                                    country-code={paramModel?.countryCode}
                                    backfillValue={inputValue}
                                />
                            </div>
                            <div className="ag-bookmark"
                                style={{ display: paramModel.bookmarksPara === "hide" ? "none" : undefined }} >
                                <label className="bookmark-title">
                                    {currentLanguage.txt_BookmarkReminder}
                                </label>
                                <div className="select-div">
                                    <Select
                                        className="select"
                                        showSearch
                                        placeholder={currentLanguage.txt_Select}
                                        optionFilterProp="children"
                                        onChange={(option, item) => {
                                            placeNameOnchange(item);
                                        }}
                                        value={selectPlaceName}
                                        onSelect={(option, item) => {
                                            setLongFromLocationSearch((item.bookmark.longitude).toString());
                                            setLatFromLocationSearch((item.bookmark.latitude).toString());
                                            setInputValue(getFirstPart(item.bookmark.placeName));

                                            setCurrentLocation({
                                                AdminName: { _text: item.bookmark.placeName },
                                                AdminName1: { _text: item.bookmark.placeName },
                                                AdminName2: { _text: item.bookmark.placeName },
                                                AdminName3: { _text: item.bookmark.placeName },
                                                AreaId: { _text: "unknow" },
                                                CountryCode: { _text: item.bookmark.countryCode },
                                                CountryName: { _text: item.bookmark.placeName },
                                                Latitude: { _text: `${item.bookmark.latitude}` },
                                                Longitude: { _text: `${item.bookmark.longitude}` },
                                                AltName: { _text: item.bookmark.placeName },
                                                Name: { _text: item.bookmark.placeName },
                                                PlaceId: { _text: "unknow" },
                                                PostalCode: "",
                                                Score: { _text: "" }
                                            });

                                        }}
                                        size="large"
                                        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                                        options={bookmarks} />
                                    <button className="bookmark-button" onClick={addBookmarkButtonClicked}>
                                        <BookMarkIcon />
                                    </button>
                                </div>
                            </div>
                            <div style={{display:agWeather}} className="ag-weather-list">
                                <label className="top-title">
                                    {currentLanguage.txt_WeatherConditions}
                                </label>
                                <label className="sub-title">
                                    {currentLanguage.txt_SelectWeatherConditions}
                                </label>
                                {/* left location-2 search */}
                                <Spin spinning={weatherListLoading}>
                                    <daily-widget
                                        ref={widgetRef}
                                        key={dailyKey}
                                        lat={latFromLocationSearch??(paramModel?.latitude?.toString())}
                                        lon={longFromLocationSearch??(paramModel?.longitude?.toString())}
                                        number-of-days={paramModel?.numberOfDays?.toString()??"5"}
                                        unit={paramModel?.unit??"metric"}
                                        source="greencast"
                                        language={paramModel?.language??"en"}
                                        country-code={paramModel?.countryCode}
                                        data-source="meteoblue"
                                    />
                                </Spin>
                            </div>
                        </div>
                        <div className="accurate-right">
                            <div className="top-header-container-div">
                                <Spin spinning={topInfoCardLoading}>
                                    <div className="top-header-top-div">
                                        <div className="left-title">
                                            <label className="main-lable">
                                                {currentLocation?.AdminName?._text?.split(",")[0] || "Unknow"}
                                            </label>
                                            <label className="sub-lable">
                                                {`${currentLocation?.Longitude?._text || "0"}, ${currentLocation?.Latitude?._text || "0"}`}
                                            </label>
                                        </div>
                                        <currentcondition-widget
                                            key={currentconditionKey}
                                            lat={latFromLocationSearch??(paramModel?.latitude?.toString())}
                                            lon={longFromLocationSearch??(paramModel?.longitude?.toString())}
                                            unit={paramModel?.unit??"metric"}
                                            source="weatherdata"
                                            language={paramModel?.language}
                                            country-code={paramModel?.countryCode}
                                            data-source="meteoblue"
                                        ></currentcondition-widget>
                                        <div className="top-right-div">
                                            <button
                                                className="graphic-button-chart"
                                                onClick={() => setShowGraphicChart(!showGraphicChart)}
                                            >
                                                {currentLanguage.lbl_seegraphicchart}
                                            </button>
                                        </div>
                                    </div>
                                    <IF show={showGraphicChart}>
                                        <div className="graphic-chart-div">
                                            <div className="first-div">
                                                <ReactEcharts
                                                    option={option}
                                                    style={{
                                                        width: "auto",
                                                        height: "95%",
                                                        backgroundColor: "white",
                                                        borderRadius: "5px"
                                                    }}
                                                />
                                            </div>
                                            <div className="second-div">
                                                <ReactEcharts
                                                    option={secondChartOption}
                                                    style={{
                                                        width: "auto",
                                                        height: "95%",
                                                        backgroundColor: "white",
                                                        borderRadius: "5px"
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </IF>
                                </Spin>
                            </div>
                            <div className="circle-round-div">
                                <Spin spinning={sprayLoading}>
                                    <spraying-widget
                                        key={sprayingKey}
                                        lat={latFromLocationSearch??(paramModel?.latitude?.toString())}
                                        lon={longFromLocationSearch??(paramModel?.longitude?.toString())}
                                        source="weatherdata"
                                        language={paramModel?.language}
                                        country-code={paramModel?.countryCode}
                                        type="spray"
                                        crop-list={`${paramModel.modelName}|${paramModel.cropList}`}
                                        default-crop={paramModel.modelName}
                                        date={weatherDate}
                                        data-source="meteoblue"
                                        width="auto"
                                    ></spraying-widget>
                                </Spin>
                            </div>
                            <div style={{display:agWeathermobile}} className="ag-weather-list-mobile">
                                <label className="top-title">
                                    {currentLanguage.txt_WeatherConditions}
                                </label>
                                <label className="sub-title">
                                    {currentLanguage.txt_SelectWeatherConditions}
                                </label>
                                {/* left location-2 search */}
                                <Spin spinning={weatherListLoading}>
                                    <div className="list-div">
                                        {weatherForcastDailyList.map((item) =>
                                            <WeatherCard
                                                onClick={(data) => {
                                                    const newWeatherForcastDailyList = weatherForcastDailyList.map((item) => {
                                                        const newItem = { ...item };
                                                        if (newItem.date === data.date && newItem.selected === false) {
                                                            newItem.selected = true;
                                                            setCurrentWeatherDate(item);
                                                        } else {
                                                            newItem.selected = false;
                                                        }
                                                        return newItem;
                                                    });

                                                    dispatch(updateWeatherForcastdailyList(newWeatherForcastDailyList));
                                                }}
                                                weatherData={item}
                                                key={item.date}
                                            />)
                                        }
                                    </div>
                                </Spin>
                            </div>
                            <div className="table-detail-div">
                                <Tabs
                                    tabBarStyle={{
                                        marginLeft: "10px",
                                        fontFamily: "Noto-Sans-Regular",
                                        fontSize: "14px",
                                        color: "#14151C"
                                    }}
                                    // items={tabItems}
                                    items={newTabItems}
                                    animated={true}
                                />
                                <div className="weather-indicate-icon-container">
                                    <ForcastButton
                                        buttonName={currentLanguage.txt_SeeForecastProviderData}
                                        closeName={currentLanguage.close}
                                        forecastProvider={currentLanguage.txt_ForecastProviderData}
                                        meteoblueForecast={currentLanguage.txt_MeteoblueForecast}
                                        modalContentOne={currentLanguage.txt_ForecastProviderContentP1}
                                        modalContentTwo={currentLanguage.txt_ForecastProviderContentP2}
                                        modalContentThree={currentLanguage.txt_ForecastProviderContentP3}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="error_page">
                        <div className="error_content">
                            <span>There is an issue with accessing the page. </span>
                            <span>Please provide the correct token.</span>
                        </div>
                    </div>
            }
        </>
    );
};

export default AccurateWeather;